/**
 * "Was this quotation mailed to the customer separately?" — marking a quotation sent without
 * sending it (Akhil, 2026-09-18).
 *
 * A quotation the sales team mails from Outlook still has to READ as sent: the RFQ builder
 * locks, the board card moves to Quotation Sent, the history shows a send, and the next one is
 * a revision. Measured 2026-09-18 on QTN-2026-00063: a mailed quotation is `status: Quoted`,
 * `sent_at`, `sent_to` on the Quotation (all three writable through `update_quotation`, the
 * read-only flags being form-only) and `Quotation Sent` on the enquiry. This patch reproduces
 * that state exactly, with `sent_to` saying it was marked by hand — so nobody later reads the
 * record as a mail the app sent to somebody.
 */

import type { EnquiryStatus } from './types'

const pad = (n: number) => String(n).padStart(2, '0')
/** `"YYYY-MM-DD HH:mm:ss"` in local time — the wire's own datetime convention. */
export const siteDateTime = (d: Date) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`

export function markSentPatch(
  now: Date,
  by: string | null,
): { quotation: { status: 'Quoted'; sent_at: string; sent_to: string }; enquiryStatus: EnquiryStatus } {
  return {
    quotation: {
      status: 'Quoted',
      sent_at: siteDateTime(now),
      sent_to: by ? `Marked as sent outside the app by ${by}` : 'Marked as sent outside the app',
    },
    enquiryStatus: 'Quotation Sent',
  }
}
